module.exports = __webpack_public_path__ + "static/medical-f3580ce75fdf170a5fb028a8a992c1d9.jpg";